import gql from 'graphql-tag';

export default gql`
    mutation UpdateLofaScheduleInfo($input: LofaScheduleEdit) {
        updateLofaScheduleInfo(input: $input) {
            errors
        }
    }
`;
